import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["beforeUpload", "onRemove", "fileList"];

var _templateObject;

import React from 'react';
import { Upload as AntUpload } from 'antd';
import styled from 'styled-components';
var UploadContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  color: #A2A6A8;\n  & > span {\n    display: flex;\n    overflow: hidden;\n    & > .ant-upload-select {\n      margin-right: 10px;\n    }\n    & > .ant-upload-list {\n      flex: 1;\n      color: ", ";\n      overflow: hidden;\n    }\n  }\n"])), function (props) {
  return props.theme.colors.primary;
});
/**
 * @param {import('antd/es/upload/Upload').UploadProps} props
 */

var Upload = function Upload(_ref) {
  var _beforeUpload = _ref.beforeUpload,
      _onRemove = _ref.onRemove,
      fileList = _ref.fileList,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(AntUpload, _extends({
    fileList: fileList,
    beforeUpload: function beforeUpload() {
      if (typeof _beforeUpload === 'function') {
        _beforeUpload.apply(void 0, arguments);
      }

      return false;
    },
    onRemove: function onRemove(removedItem) {
      if (typeof _beforeUpload === 'function') {
        _beforeUpload(undefined, fileList.filter(function (file) {
          return file.uid !== removedItem.uid;
        }));
      }

      if (typeof _onRemove === 'function') {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _onRemove.apply(void 0, [removedItem].concat(args));
      }
    }
  }, props));
};

Upload.InlineUpload = function (props) {
  var placeHolder = props.placeHolder,
      fileList = props.fileList;
  return /*#__PURE__*/React.createElement(UploadContainer, null, /*#__PURE__*/React.createElement(Upload, props), fileList && fileList.length === 0 && placeHolder && /*#__PURE__*/React.createElement("p", null, placeHolder));
};

export default Upload;